import { deleteDataAPI, getDataAPI, postDataAPI } from "../../../services/apiWrapper";
import { errorAlert, successAlert } from "../../../utils/alert";

/*
 * Gallery albums - Events, Functions, Seminars.
 *
 * The website reads the open list (active albums with a count, so an empty
 * album can be left out of the filter bar); the council reads all of them.
 */

const adminToken = () => localStorage.getItem("adminToken");

/**
 * @param {object} params  active: 1 for the website, type: photo | video
 */
export const getGalleryAlbums = (params = {}) => async (dispatch) => {
  try {
    const q = new URLSearchParams();
    ["active", "type"].forEach((key) => {
      if (params[key]) q.append(key, params[key]);
    });
    const suffix = q.toString() ? `?${q.toString()}` : "";

    const url = params.active
      ? `admin/gallery/albums${suffix}`
      : `admin/gallery/category/list${suffix}`;

    const response = await dispatch(
      getDataAPI(url, params.active ? undefined : adminToken())
    );
    return response.data.data || [];
  } catch (error) {
    return [];
  }
};

/**
 * Which years the gallery actually holds, newest first, so a filter bar
 * never offers a year with nothing behind it.
 *
 * @param {string} fileType  "gallery" for photos, "video", or blank for both
 */
export const getGalleryYears = (fileType) => async (dispatch) => {
  try {
    const suffix = fileType ? `?file_type=${fileType}` : "";
    const response = await dispatch(getDataAPI(`admin/gallery/years${suffix}`));
    return response.data.data || [];
  } catch (error) {
    return [];
  }
};

export const saveGalleryAlbum = (data, id) => async (dispatch) => {
  try {
    const url = id
      ? `admin/gallery/category/update/${id}`
      : "admin/gallery/category/create";
    const response = await dispatch(postDataAPI(url, data, adminToken()));
    successAlert(response.data.message);
    return true;
  } catch (error) {
    errorAlert(error.response?.data?.message || "The album could not be saved.");
    return false;
  }
};

export const deleteGalleryAlbum = (id) => async (dispatch) => {
  try {
    const response = await dispatch(
      deleteDataAPI(`admin/gallery/category/delete/${id}`, adminToken())
    );
    successAlert(response.data.message);
    return true;
  } catch (error) {
    errorAlert(
      error.response?.data?.message || "The album could not be deleted."
    );
    return false;
  }
};
